export function isInArray<T extends string | null | undefined>(array: readonly T[], value?: string | null): value is T {
  return !!value && array.some((v) => v === value)
}
